let utils = require('../../../actions/utils');
let analytics = require('../../../actions/analytics');
let auth = require('../../../actions/auth');
let cookie = require('../../../actions/cookie');
let registration = require('../../../actions/auth/registration');
let page = require('../../../actions/page');
let footer = require('../../../actions/layout/footer');
let seo = require('../../../actions/seo');
let { initUserType } = require('../../../actions/account/user-form');
let error = require('../../../actions/error');

module.exports = [
    analytics.parseUtmFromQuery,
    utils.set('layout', 'auth'),
    [
        cookie.checkExistCookie, {
            exist: [
                utils.set(['page', 'name'], 'alert'),
                utils.set(['auth', 'alert', 'type'], 'redirect')
            ],
            notExist: [
                page.setCurrentPage
            ]
        }
    ],
    [
        registration.getCountries, {
            success: [
                utils.setFromArgsToState('countries', ['registration', 'countries'])
            ],
            error: [ error.internalError('registration.getCountries') ]
        }
    ],
    utils.setPopupVisibility('registrationCountryDropdown', ['registration', 'popups', 'countryDropdown', 'isOpen']),
    seo.setDashboardMeta('Регистрация - Библиотека данных', 'Регистрация в библиотеке данных'),
    auth.setComputedFields,
    registration.setComputedFields,
    initUserType(['registration']),
    analytics.pageview,
    footer.setCopyrightYear
];



// WEBPACK FOOTER //
// ./signals/pages/auth/registration.js